import { type Organization } from "@overmap-ai/common"
import { selectOrganizationsMapping } from "@overmap-ai/core"
import { createSelector } from "@reduxjs/toolkit"

import type { RootSelector } from "../typings"
import { selectActiveOrganizationId } from "./app"

export const selectActiveOrganization: RootSelector<Organization | undefined> = createSelector(
	[selectOrganizationsMapping, selectActiveOrganizationId],
	(organizations, activeOrganizationId) => {
		return activeOrganizationId ? organizations[activeOrganizationId] : undefined
	},
)
